import { render, staticRenderFns } from "./CanopySidebar.vue?vue&type=template&id=048723ae&scoped=true&"
import script from "./CanopySidebar.vue?vue&type=script&lang=ts&"
export * from "./CanopySidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048723ae",
  null
  
)

export default component.exports